const SkeletonCourses = () => {
  return <div className="skeleton-courses-card"></div>;
};

export default SkeletonCourses;
